export const getOfflineReviewsCount = (state) => state.offlineReviewsCount
